import React,{Component} from 'react';
import {ref} from '../config/constants'
import {formatPrice,formatQuantity} from '../helpers/helpers'

class QBendedView extends Component{
    constructor(){
        super();
        this.state ={
            bended :{}
        }
            
    }
    
    componentWillMount(){
        let category = ref.child("BendedPrice").orderByChild('status').equalTo('Active');
            category.on("value", function(snap){
                this.setState({
                    bended : snap.val()
                })
            }.bind(this))

    }

    render() { 
           
           var thick = this.props.product.productThickness
                thick = thick.slice(-3)
               
        return (
                <tr>
                    <td>{this.props.product.productName}</td>
                    <td>
                    { 
                        Object.keys(this.state.bended).map(key=>{
                            if(key === this.props.product.productDimension){
                            var product =  this.state.bended[key] 
                            
                            return product.dimension  
                            }
                        })
                    }
                    </td>
                    <td>0.{thick}</td>
                    <td>{formatQuantity(this.props.product.productNumber)}</td>
                    <td>{this.props.product.productUnit}</td>
                    <td>{formatPrice(this.props.product.productPrice)}</td>
                    <td>{this.props.product.productUnit}</td>
                    <td>{this.props.product.productDiscount}%</td>
                    <td>{formatPrice(this.props.product.productTotal)}</td>
                </tr>
                    
 
        );
    }
}

export default  QBendedView;


// WEBPACK FOOTER //
// ./src/components/QBendedView.js